import * as React from 'react';
import { Component } from 'react';

interface Props {
  tabs: string[];
  children: React.ReactNode;
}

interface State {
  selectedTab: number;
}

export class GeneralMessagePreviewTabs extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { selectedTab: 0 };
  }

  onTabClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, index: number) => {
    event.preventDefault();
    this.setState({ selectedTab: index });
  };

  render() {
    const { selectedTab } = this.state;

    return (
      <div>
        <div className="gmPreviewTabs">
          {this.props.tabs.map((tab, index) => (
            <button
              key={tab}
              type="button"
              className={`gmPreviewTabs__tab ${selectedTab === index ? 'gmPreviewTabs__tab--active' : ''}`}
              onClick={event => this.onTabClick(event, index)}
            >
              {tab}
            </button>
          ))}
        </div>
        <div>{React.Children.toArray(this.props.children)[selectedTab]}</div>
      </div>
    );
  }
}
